import { oz } from '@weft/utils';
import { INTEGRATION_TYPES } from '../integration-types-schema';

export const BrearerTokenDataSchema = oz.object({ 
  integrationType: oz.literal(INTEGRATION_TYPES.bearerToken), 
  token: oz.string(), 
});

export type BrearerTokenData = oz.infer<typeof BrearerTokenDataSchema>;